import { sumBy } from "./sum-by"

/**
 * Calculates the average of array elements based on a selector function
 */
export const meanBy = <T>(array: T[], selector: (item: T) => number): number => {
  if (array.length === 0) return 0
  return sumBy(array, selector) / array.length
}
